import { render, staticRenderFns } from "./ifc-document-selector-modal.vue?vue&type=template&id=5b541458&scoped=true"
import script from "./ifc-document-selector-modal.vue?vue&type=script&lang=js"
export * from "./ifc-document-selector-modal.vue?vue&type=script&lang=js"
import style0 from "./ifc-document-selector-modal.vue?vue&type=style&index=0&id=5b541458&prod&lang=css"
import style1 from "./ifc-document-selector-modal.vue?vue&type=style&index=1&id=5b541458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b541458",
  null
  
)

export default component.exports